import React, { useState } from "react";
import Footer from "../components/Shared/Footer";

const ReadyReckoner = () => {

  return (
    <div>

      <section className="breadcrumb-section pt-0">
      <div className="container-fluid-lg">
          <div className="row">
              <div className="col-12">
                  <div className="breadcrumb-contain">
                      <h2>Ready Reckoner</h2>
                      <nav>
                          <ol className="breadcrumb mb-0">
                              <li className="breadcrumb-item">
                                  <a href="/">
                                      <i className="fa-solid fa-house"></i>
                                  </a>
                              </li>
                              <li className="breadcrumb-item active">Ready Reckoner</li>
                          </ol>
                      </nav>
                  </div>
              </div>
          </div>
      </div>
      </section>
      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-12 col-md-6">
              <img src="assets/images/ready-reckoner/pdf_1.jpg" style={{width: '100%', marginTop: '20px'}}/>
            </div>
            <div className="col-12 col-md-6">
              <img src="assets/images/ready-reckoner/pdf_2.jpg" style={{width: '100%', marginTop: '20px'}}/>
            </div>
          </div>
        </div>

      </section>

      <div>
          <Footer />
      </div>
    </div>
  );
};

export default ReadyReckoner;
